<template>
  <div>
      <input
        type="button"
        :class="buttonClass"
        :value="buttonText" 
        @click="toggleFormVisibility"
      />

    <!-- Formulário Modal (aparece ao clicar no botão) -->
    <div v-if="isFormVisible" class="form-container" @click.self="closeForm">
      <div class="form-modal p-5">
        <div class="f-3">Contact Us</div>
        <form @submit.prevent="submitForm">
          <input type="text" id="name" v-model="formData.name" required class="inputx amarelo f-6" placeholder="your name"/>

          <input type="email" id="email" v-model="formData.email" required class="inputx amarelo f-6" placeholder="your e-mail"/>

          <input type="text" id="phone" v-model="formData.phone" required class="inputx amarelo f-6" placeholder="your phone"/>

          <textarea id="message" v-model="formData.message" required class="inputx amarelo f-6" placeholder="your message"></textarea>

          <button type="submit" class="btnx1">Submit</button>
        </form>
        <div v-if="submissionStatus" class="thank-you-message">
          <p>{{ submissionMessage }}</p>
        </div>
      </div>
    </div>

    <!-- Mensagem de erro ou sucesso -->
    <transition name="zoom">
      <div v-if="showError" class="error-message" @click="closeMessage">
        <div>
          <span class="amarelo">{{ message }}</span>
        </div>
        <div>
          <!-- Botão OK abaixo do texto -->
          <button class="btnx1 mt-4" @click="closeMessage">OK</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isFormVisible: false,  // Controla a visibilidade do formulário
      formData: {
        name: '',
        email: '',
        phone: '',
        message: '',
      },
      submissionStatus: false,  // Controla a visibilidade da mensagem de sucesso
      submissionMessage: '',  // Mensagem de sucesso ou erro
      showError: false,  // Controle para mostrar a mensagem de erro
      message: "Please enter your email!", // Mensagem de erro ou sucesso
    };
  },

  props: {
    buttonText: {
      type: String,
      required: true
    },
    buttonClass: {
      type: String,
      required: true
    }
  }, 
    
  methods: {
    toggleFormVisibility() {
      // Exibe o formulário com efeito fade-in
      this.isFormVisible = true;
      this.$nextTick(() => {
        document.querySelector('.form-container').classList.add('fade-in');
      });
    },
    closeForm() {
      // Fecha o formulário com efeito fade-out
      this.isFormVisible = false;
    },
    async submitForm() {
      try {
        const response = await fetch('https://solutionart.com.br/robo/v2025/util/post', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.formData),
        });

        const result = await response.json();
        console.log('result', result);
        if (result.ok === 1) {
          this.submissionMessage = 'Thank you for sending your message!';
          this.submissionStatus = true;

          // Fade out após 4 segundos
          setTimeout(() => {
            this.isFormVisible = false;
          }, 4000);
        } else {
          this.submissionMessage = 'Something went wrong, please try again.';
          this.submissionStatus = true;
        }
      } catch (error) {
        this.submissionMessage = 'Error sending your message. Please try again later.';
        this.submissionStatus = true;
      }
    },
    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return regex.test(email);
    },

    async sendEmail() {
      // Verifique se o email está vazio
      if (!this.email) {
        this.showError = true;
        this.message = "Please enter your email!";
        return;
      }

      // Verifique se o email é válido
      if (!this.isValidEmail(this.email)) {
        this.showError = true;
        this.message = "Please enter a valid email!";
        return;
      }

      try {
        // Enviar o email via POST para o servidor
        const response = await fetch('https://solutionart.com.br/robo/v2025/util/post', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email }), // Envia o email como JSON
        });

        const data = await response.json();

        if (data.ok === 1) {
          // Se o POST for bem-sucedido, exibe a mensagem de sucesso
          this.message = "Obrigado por se cadastrar!";
        } else {
          // Caso o POST não seja bem-sucedido
          this.message = "Error sending email.";
        }

        this.showError = true; // Exibe a mensagem
      } catch (error) {
        console.error('Error:', error);
        this.message = "An error occurred. Please try again.";
        this.showError = true; // Exibe a mensagem de erro
      }
    },

    closeMessage() {
      // Fecha a mensagem com animação de zoom-out e fade-out
      this.showError = false;
    },
  },
};
</script>

<style scoped>
:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --blue2: #83DEF4;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}

@font-face {
  font-family: 'MinhaFonte';
  src: url('@/assets/ObjectSans-Regular.otf') format('truetype');
}


.amarelo {
  color: var(--cream);
}

.left {
  text-align: left;
}

.border-null {
  border: 1px solid var(--mid-green);
}

.border-log {
  border: 4px solid rgb(0, 0, 255);
}

.hero3 {
  position: relative;
  height: 500px;
  background: url('@/assets/bg04.jpg') no-repeat center center/cover;
  background-attachment: fixed;
  background-size: cover;
  justify-content: center;
  transition: background-position 0.2s ease-out;
}

.hero3::before {
  content: '';
  top: 0;
  left: 0;
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.hero3-text {
  position: absolute;
  top: 35%;
  color: #e0d0a6;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
}




.btnx {
  font-family: 'Object Sans';
  color: var(--cream);
  padding: 2rem 4rem 1.5rem;
  border: 0px solid #e0d0a6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.4rem;
  letter-spacing: 0.15rem;
}
.btnx1:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}


.btnx2 {
  border: 0px solid rgb(0, 0, 255);
  padding: 0.1rem 0rem 1.5rem;
  background-color: transparent;
  text-transform: uppercase;
  line-height: 1.9rem;
  background-color: transparent;

}

.btnx:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.btnx1 {
  font-family: 'Object Sans';
  color: var(--cream);
  padding: 2rem 4rem 1.5rem;
  border: 1px solid #e0d0a6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.4rem;
  letter-spacing: 0.15rem;
  line-height: 1.9rem;
  background-color: transparent;

}
.btnx1:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}


.btnx2 {
  border: 0px solid rgb(0, 0, 255);
  background-color: transparent;
  text-transform: uppercase;
  color: var(--green);
  font-family: 'Object Sans';
  letter-spacing: 0.15rem;  
  font-size: 2.2rem;
}


.form-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
  z-index: 20;
}

.form-container.fade-in {
  opacity: 1;
  pointer-events: auto;
}

.form-modal {
  font-family: 'Object Sans';
  background: var(--dark-green);
  color: var(--cream);
  padding: 20px;
  border-radius: 0px;
  width: 70%;
  max-width: 600px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

form label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}

form input, form textarea {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 0px;
}

form button {
  background-color: var(--cream);
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 0px;
}

.thank-you-message {
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #4CAF50;
}

.error-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  background-color: rgba(83, 109, 63, 0.96);
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  z-index: 9999;
  animation: zoomIn 0.5s ease-out;
  flex-direction: column;
  padding: 2rem;
}

.inputx {
  font-family: MinhaFonte;
  background-color: transparent; 
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 1px solid #e0d0a6;
}

.inputx::placeholder {
  color: #e0d0a6;
  opacity: 0.25;
}        

@keyframes zoomIn {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

.zoom-leave-active {
  animation: zoomOut 0.5s ease-in-out;
}

@keyframes zoomOut {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
}
</style>
